<app-page-layout
  [pageTitle]="'App Registration'"
  [subtitle]="'Manage clients'">

  <div page-actions class="flex items-center gap-2">
    <p-button
      label="Add Client"
      icon="pi pi-plus"
      (onClick)="openAddClientDialog()"
      severity="primary"
      size="small"
      outlined>
    </p-button>
  </div>

  <div class="flex justify-between items-center mb-4">
    <div class="flex items-center gap-3">
      <!-- Search -->
      <div class="relative w-72">
        <p-iconField iconPosition="left" class="w-72">
          <p-inputIcon styleClass="pi pi-search"></p-inputIcon>
          <input
            type="text"
            pInputText
            placeholder="Search clients..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
            class="w-full"/>
        </p-iconField>
      </div>
    </div>
  </div>

  <!-- State Container -->
  <app-state-container
    [state]="viewState()"
    loadingMessage="Loading clients..."
    loadingSubMessage="Please wait while we fetch your clients"
    emptyIcon="pi-id-card"
    emptyTitle="No clients found"
    [emptyMessage]="emptyStateMessage()"
    [showEmptyAction]="true"
    emptyActionLabel="Add Client"
    emptyActionIcon="pi-plus"
    [emptyActionOutlined]="true"
    [showClearFilters]="showClearFilters()"
    [errorMessage]="errorMessage()"
    (emptyAction)="openAddClientDialog()"
    (clearFilters)="clearFilters()"
    (retry)="retryLoad()"
  >
    <div class="bg-white dark:bg-zinc-950 rounded-lg border border-surface-200 dark:border-zinc-800">
      <p-table
        [value]="filteredClients()"
        [loading]="loading()"
        class="p-datatable-sm"
        [rowHover]="true"
        [resizableColumns]="true"
        columnResizeMode="fit"
        stateStorage="local"
        stateKey="app-registration-table">
        
        <ng-template pTemplate="header">
          <tr class="bg-surface-100 text-surface-600">
            <th
              pResizableColumn
              style="min-width:200px;"
              class="px-4 py-2 bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Client Name
            </th>
            <th
              pResizableColumn
              style="min-width:200px;"
              class="px-4 py-2 bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Client ID
            </th>
            <th
              pResizableColumn
              style="min-width:200px;"
              class="px-4 py-2 bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200">
              Created Date
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-client>
          <tr class="border-t border-surface-200 dark:border-surface-700 hover:bg-surface-50 dark:hover:bg-surface-800 transition">
            <td class="px-4 py-2 flex items-center gap-2">
              <div class="w-6 h-6 flex items-center justify-center rounded-full
                bg-primary-100 text-primary-600 text-xs font-semibold">
                {{ getInitials(client.clientId) }}
              </div>
              <span class="text-primary-600 dark:text-primary-400 cursor-pointer"
                routerLink="/app-registration/{{ client.id }}">
                {{ client.clientName || client.clientId }}
              </span>
            </td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">
              {{ client.id }}
            </td>
            <td class="px-4 py-2 text-surface-700 dark:text-surface-300">
              {{ client.createdDate | date:'dd MMM yyyy, hh:mm a' }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center py-6 text-surface-500">
              No applications found
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </app-state-container>

  <!-- Dialog Container -->
  <ng-container #dialogContainer></ng-container>

</app-page-layout>

<p-toast></p-toast>